// extracted by css-extract-rspack-plugin
export default {"SettingsSection":"qFnGE"};